import { render, staticRenderFns } from "./NLPAnalysis.vue?vue&type=template&id=2158251e&scoped=true"
import script from "./NLPAnalysis.vue?vue&type=script&lang=js"
export * from "./NLPAnalysis.vue?vue&type=script&lang=js"
import style0 from "./NLPAnalysis.vue?vue&type=style&index=0&id=2158251e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2158251e",
  null
  
)

export default component.exports